import { noop } from 'lodash';
import moment from 'moment';
import { createContext, useContext } from 'react';
import { PAST_7_DAYS } from 'ui/datePicker/helpers';
import { guessCurrentTimeZone } from 'utils/timeZone';
import { DateParams, Preset } from '../types';

type TimeFiltersContextState = {
  dateParams: DateParams;
  setDateParams: (dateParams: DateParams) => void;
  timezone: string;
  setTimezone: (timezone: string) => void;
  timePreset: Preset;
  setTimePreset: (timePreset: Preset) => void;
};

export const defaultTimeFiltersState = {
  dateParams: {
    startTime: moment().subtract(7, 'd'),
    endTime: moment(),
  },
  setDateParams: noop,
  timezone: guessCurrentTimeZone(),
  setTimezone: noop,
  timePreset: PAST_7_DAYS as Preset,
  setTimePreset: noop,
};

export const TimeFiltersContext = createContext<TimeFiltersContextState>(defaultTimeFiltersState);

export const useTimeFiltersContext = () => useContext(TimeFiltersContext);
